export const contentEn = {
  homeTitle: 'GARUDAFOOD X-QUEST',
  homeDesc: 'Explore the Garudafood factory with a sophisticated and futuristic experience! Choose the location you want to visit!',
  venue01: 'Gery X-Quest (Gresik)',
  venue02: 'Chocolatos X-Quest (Sumedang)',
  venue03: 'Under Construction (Pati)',
  loremIpsum: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed in accumsan augue. Fusce ac metus vulputate, aliquet diam fringilla, varius tellus. Donec ut metus quis augue porttitor tempor ut vel metus. Fusce hendrerit lacinia sem sed sodales.',
};

export const contentId = {
  homeTitle: 'GARUDAFOOD X-QUEST',
  homeDesc: 'Jelajahi pabrik Garudafood dengan pengalaman canggih dan futuristik! Ayo pilih lokasi yang ingin kamu kunjungi!',
  venue01: 'Gery X-Quest (Gresik)',
  venue02: 'Chocolatos X-Quest (Sumedang)',
  venue03: 'Dalam Tahap Pengembangan (Pati)',
  loremIpsum: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed in accumsan augue. Fusce ac metus vulputate, aliquet diam fringilla, varius tellus. Donec ut metus quis augue porttitor tempor ut vel metus. Fusce hendrerit lacinia sem sed sodales.',
};

export const venueId = [
  {
    path: '',
    title: 'Gery X-Quest (Gresik)',
    image: '/assets/images/venue/01_gery.png'
  },
  {
    path: 'chocolatos',
    title: 'Chocolatos X-Quest (Sumedang)',
    image: '/assets/images/venue/02_chocolatos.png'
  },
  {
    path: '',
    title: 'Dalam Tahap Pengembangan (Pati)',
    image: '/assets/images/venue/00_maintenance.png'
  }
]

export const venueEn = [
  {
    path: '',
    title: 'Gery X-Quest (Gresik)',
    image: '/assets/images/venue/01_gery.png'
  },
  {
    path: 'chocolatos',
    title: 'Chocolatos X-Quest (Sumedang)',
    image: '/assets/images/venue/02_chocolatos.png'
  },
  {
    path: '',
    title: 'Under Construction (Pati)',
    image: '/assets/images/venue/00_maintenance.png'
  }
]

export const contentChocoEn = {
  linkHome: 'Home',
  linkGallery: 'Gallery',
  heroDescChoco: 'Experience the excitement with multisensory rides, 3D glasses, interactive games, and 360° LED displays that transform images into animations.',
  titleVideoChoco: 'A Story Full of Innovation',
  descVideoChoco: 'Enter a futuristic world full of adventure and exploration, wrapped in 360° LED technology that will transport you into a whole new world.',
  titleGalleryChoco: 'Chocolatos X-Quest Gallery',
  titleCTAChoco: 'Ready to Start the Adventure?',
  btnIG: 'View on IG',
  btnReservation: 'Reserve Now',
  copyright: '&copy; 2025 Garudafood Putra Putri Jaya TBK. All Rights Reserved.',
  agreement: 'Agreement',
  terms: 'Terms and Conditions',
  terms_date: 'Latest Update 01/08/2025',
  terms_accept: 'Accept Terms & Conditions',
};

export const contentChocoId = {
  linkHome: 'Beranda',
  linkGallery: 'Galeri',
  heroDescChoco: 'Rasakan pengalaman seru dengan wahana multisensori, kacamata 3D, permainan interaktif, hingga LED 360 yang mengubah gambar menjadi animasi.',
  titleVideoChoco: 'LED 360 Terbesar di Indonesia!',
  descVideoChoco: 'Masuki dunia futuristik penuh petualangan dan eksplorasi rasa, dibalut teknologi LED 360° yang akan membawa kamu semua masuk ke dalam dunia baru.',
  titleGalleryChoco: 'Galeri Chocolatos X-Quest',
  titleCTAChoco: 'Siap Memulai Petualangan?',
  btnIG: 'Lihat di IG',
  btnReservation: 'Reservasi Sekarang',
  copyright: '&copy; 2025 Garudafood Putra Putri Jaya TBK. All Rights Reserved.',
  agreement: 'Persetujuan',
  terms: 'Syarat dan Ketentuan',
  terms_date: 'Terbaru 01/08/2025',
  terms_accept: 'Setujui Peraturan',
};

export const heroChoco = [
  {
    image: '/assets/images/slider/sumedang/space.webp',
    title_id: 'Petualangan Penuh Inovasi',
    title_en: 'An Adventure Full of Innovation',
    desc_id: 'Ruang belajar interaktif yang dapat diakses oleh berbagai lapisan masyarakat.',
    desc_en: 'Interactive learning spaces accessible to all segments of society',
  },
  {
    image: '/assets/images/slider/sumedang/gondola.webp',
    title_id: '5DX-Perience Immersive LED Pertama di Indonesia!',
    title_en: '5DX-Perience: Indonesia\'s First Immersive LED Experience!',
    desc_id: 'Wahana eduwisata berbasis teknologi LED imersif 5DX-perience menjelajahi dunia futuristik langsung dari kawasan pabrik Garudafood Sumedang.',
    desc_en: 'The 5DX-perience immersive LED technology-based educational tour explores a futuristic world directly from the Garudafood Sumedang factory area.',
  },
  {
    image: '/assets/images/slider/sumedang/merch.webp',
    title_id: 'Kenangan Seru untuk Dibawa Pulang',
    title_en: 'Exciting Memories to Take Home',
    desc_id: 'Menawarkan beragam produk Garudafood serta koleksi merchandise edisi terbatas bertema Chocolatos X-Quest.',
    desc_en: 'Offering a wide range of Garudafood products and a limited edition collection of Chocolatos X-Quest themed merchandise.',
  },
]

// export const heroChocoMobile = [
//   {
//     image: '/assets/images/slider/sumedang/slide_mobile_01.jpg' 
//   },
//   {
//     image: '/assets/images/slider/sumedang/slide_mobile_02.jpg'  
//   },
//   {
//     image: '/assets/images/slider/sumedang/slide_mobile_03.jpg' 
//   }
// ]

export const heroChocoMobile = [
  {
    image: '/assets/images/slider/sumedang/hologram.webp',
    title_id: 'Perjalanan Penuh Inovasi',
    title_en: 'A Journey Full of Innovation',
    desc_id: 'Chocolatos X-Quest, wahana wisata edukasi berbasis teknologi LED imersif 5D X-perience pertama di Indonesia.',
    desc_en: 'Chocolatos X-Quest, Indonesia\'s first 5D X-perience immersive LED technology-based educational tourist attraction',
  },
  {
    image: '/assets/images/slider/sumedang/gondola.webp',
    title_id: 'Edukasi Imersif Untuk Generasi Muda!',
    title_en: 'Immersive Education for the Younger Generation!',
    desc_id: 'Menggabungkan edukasi, teknologi, dan petualangan seru dalam satu pengalaman tak terlupakan.',
    desc_en: 'Combining education, technology, and exciting adventures into one unforgettable experience.',
  },
  {
    image: '/assets/images/slider/sumedang/merch.webp',
    title_id: 'Kenangan Seru untuk Dibawa Pulang',
    title_en: 'Exciting Memories to Take Home',
    desc_id: 'Merchandise eksklusif yang mengabadikan pengalaman seru dan menemani keseharianmu bahkan setelah petualangan berakhir.',
    desc_en: 'Exclusive merchandise that captures the exciting experience and accompanies your daily life even after the adventure is over.',
  },
]

export const uriChoco = {
  youtubeVideo: 'https://www.youtube.com/embed/I2-ayBZr03M'
}

export const socmedGF = {
  facebook: 'https://www.facebook.com/Garudafood-128133043916752/',
  twitter: 'https://twitter.com/Garudafood_ID',
  instagram: 'https://www.instagram.com/Garudafood_id/',
  tiktok: 'https://www.tiktok.com/@garudafood_officialstore?lang=en',
}

export const socmedChoco = {
  facebook: 'https://www.facebook.com/chocolatosxquest/',
  twitter: 'https://www.x.com/chocolatosxquest/',
  instagram: 'https://www.instagram.com/chocolatosxquest/',
  tiktok: 'https://www.tiktok.com/@chocolatosxquest/',
}

export const whatsappData = {
  phoneNumber: '628131073719',
  message:
    'Halo Admin, saya akan melakukan reservasi untuk *Chocolatos X-Quest*.\n\n*Saya sudah membaca dan menyetujui syarat & ketentuan yang ada di website* ✓',
}

export const termsDataChoco = {
  en: `
    <h4 className="fw-bold">Clause 1</h4>
    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus varius sed ligula sed tincidunt. Praesent dui augue, egestas non arcu a, tempus egestas dolor. Morbi placerat nunc at quam auctor auctor. Vivamus at nulla rutrum, posuere dui a, malesuada nunc. Nullam non dapibus sapien. Nam consequat eros sed tortor lacinia, ut egestas turpis maximus. Sed posuere lacus vitae diam porta, id egestas ligula ornare. Integer nec est et urna varius iaculis in et dolor. Nam nec laoreet turpis. Quisque facilisis lectus id ex venenatis scelerisque. Duis congue lectus ut lacus congue imperdiet viverra quis nunc. Aenean id nibh quis felis dictum feugiat. Phasellus porttitor scelerisque quam, vel maximus ipsum luctus interdum. Morbi consequat risus nulla, quis ornare tortor aliquam vel.</p>
    <br />
    <h4 className="fw-bold">Clause 2</h4>
    <p>Phasellus nec aliquet arcu. Fusce facilisis auctor pulvinar. Nullam pharetra odio a mi ultrices, at pharetra massa consequat. In ultricies scelerisque blandit. Nulla id nibh tristique, pharetra nibh vitae, dapibus arcu. Aliquam lobortis vulputate elit. Etiam vehicula enim nec volutpat dignissim. In hac habitasse platea dictumst. Proin in mi id felis tempus tincidunt.</p>
    <br />
    <h4 className="fw-bold">Clause 3</h4>
    <p>Pellentesque ultrices enim eget ornare ultricies. Vestibulum iaculis libero tortor, eget sagittis mauris rutrum non. Donec eget risus suscipit, blandit orci in, accumsan nulla. Suspendisse venenatis facilisis ultrices. Ut ac nunc arcu. Maecenas ultricies facilisis ante, ac ullamcorper leo posuere in. Vivamus placerat orci elit, ut tincidunt leo posuere condimentum. Phasellus efficitur ultricies felis, et facilisis velit fringilla eget. Morbi non nibh id massa laoreet malesuada. Morbi non arcu hendrerit, ultrices orci at, aliquet ante. Cras aliquam mi sed nibh dignissim, nec ultricies urna malesuada. Aliquam bibendum dolor vitae nisl feugiat, vel varius libero gravida. Curabitur sit amet congue ex. Quisque eleifend nec lorem at auctor. Nullam ut bibendum metus. Praesent at ultrices metus, id convallis ipsum.</p>
    <br />
    <h4 className="fw-bold">Clause 4</h4>
    <p>Nulla lacinia nibh tincidunt cursus vulputate. Phasellus pellentesque lorem vel nunc congue varius eget non enim. Nulla porttitor ligula eget lobortis molestie. In hac habitasse platea dictumst. Interdum et malesuada fames ac ante ipsum primis in faucibus. Sed volutpat justo eget est tincidunt, id varius mi tempus. Aliquam suscipit ante commodo mi placerat pulvinar. Praesent blandit sit amet nulla quis venenatis. Nulla ac nulla laoreet, venenatis ex ac, vehicula risus. Sed tristique bibendum orci at vestibulum.</p>
    <br />
    <h4 className="fw-bold">Clause 5</h4>
    <p>Curabitur massa nulla, fringilla id maximus non, bibendum porta quam. Cras consequat ultrices accumsan. In sagittis metus non nunc facilisis mattis. Mauris auctor quam at ipsum vehicula semper. Nulla luctus ligula vitae est commodo, id egestas eros facilisis. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae; In varius felis in neque sodales tempus. Morbi rutrum justo nisl, eget varius turpis rutrum congue. Donec nec pretium purus, a placerat augue. Proin sollicitudin erat ac urna accumsan, in varius ex imperdiet. Sed volutpat risus hendrerit dolor lacinia molestie. Cras ac varius felis. Nunc vel consectetur arcu, ut pharetra felis. Ut pulvinar accumsan dui, ut bibendum dolor fermentum eget. Suspendisse in ex ac enim hendrerit posuere. Phasellus egestas pulvinar purus id pretium.</p>
    <br />
    `,
  id: `
    <h4 className="fw-bold">Clause 1</h4>
    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus varius sed ligula sed tincidunt. Praesent dui augue, egestas non arcu a, tempus egestas dolor. Morbi placerat nunc at quam auctor auctor. Vivamus at nulla rutrum, posuere dui a, malesuada nunc. Nullam non dapibus sapien. Nam consequat eros sed tortor lacinia, ut egestas turpis maximus. Sed posuere lacus vitae diam porta, id egestas ligula ornare. Integer nec est et urna varius iaculis in et dolor. Nam nec laoreet turpis. Quisque facilisis lectus id ex venenatis scelerisque. Duis congue lectus ut lacus congue imperdiet viverra quis nunc. Aenean id nibh quis felis dictum feugiat. Phasellus porttitor scelerisque quam, vel maximus ipsum luctus interdum. Morbi consequat risus nulla, quis ornare tortor aliquam vel.</p>
    <br />
    <h4 className="fw-bold">Clause 2</h4>
    <p>Phasellus nec aliquet arcu. Fusce facilisis auctor pulvinar. Nullam pharetra odio a mi ultrices, at pharetra massa consequat. In ultricies scelerisque blandit. Nulla id nibh tristique, pharetra nibh vitae, dapibus arcu. Aliquam lobortis vulputate elit. Etiam vehicula enim nec volutpat dignissim. In hac habitasse platea dictumst. Proin in mi id felis tempus tincidunt.</p>
    <br />
    <h4 className="fw-bold">Clause 3</h4>
    <p>Pellentesque ultrices enim eget ornare ultricies. Vestibulum iaculis libero tortor, eget sagittis mauris rutrum non. Donec eget risus suscipit, blandit orci in, accumsan nulla. Suspendisse venenatis facilisis ultrices. Ut ac nunc arcu. Maecenas ultricies facilisis ante, ac ullamcorper leo posuere in. Vivamus placerat orci elit, ut tincidunt leo posuere condimentum. Phasellus efficitur ultricies felis, et facilisis velit fringilla eget. Morbi non nibh id massa laoreet malesuada. Morbi non arcu hendrerit, ultrices orci at, aliquet ante. Cras aliquam mi sed nibh dignissim, nec ultricies urna malesuada. Aliquam bibendum dolor vitae nisl feugiat, vel varius libero gravida. Curabitur sit amet congue ex. Quisque eleifend nec lorem at auctor. Nullam ut bibendum metus. Praesent at ultrices metus, id convallis ipsum.</p>
    <br />
    <h4 className="fw-bold">Clause 4</h4>
    <p>Nulla lacinia nibh tincidunt cursus vulputate. Phasellus pellentesque lorem vel nunc congue varius eget non enim. Nulla porttitor ligula eget lobortis molestie. In hac habitasse platea dictumst. Interdum et malesuada fames ac ante ipsum primis in faucibus. Sed volutpat justo eget est tincidunt, id varius mi tempus. Aliquam suscipit ante commodo mi placerat pulvinar. Praesent blandit sit amet nulla quis venenatis. Nulla ac nulla laoreet, venenatis ex ac, vehicula risus. Sed tristique bibendum orci at vestibulum.</p>
    <br />
    <h4 className="fw-bold">Clause 5</h4>
    <p>Curabitur massa nulla, fringilla id maximus non, bibendum porta quam. Cras consequat ultrices accumsan. In sagittis metus non nunc facilisis mattis. Mauris auctor quam at ipsum vehicula semper. Nulla luctus ligula vitae est commodo, id egestas eros facilisis. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae; In varius felis in neque sodales tempus. Morbi rutrum justo nisl, eget varius turpis rutrum congue. Donec nec pretium purus, a placerat augue. Proin sollicitudin erat ac urna accumsan, in varius ex imperdiet. Sed volutpat risus hendrerit dolor lacinia molestie. Cras ac varius felis. Nunc vel consectetur arcu, ut pharetra felis. Ut pulvinar accumsan dui, ut bibendum dolor fermentum eget. Suspendisse in ex ac enim hendrerit posuere. Phasellus egestas pulvinar purus id pretium.</p>
    <br />
    `
}


